import ComputePipeline from "../../lib/services/compute/computepipeline";

export default class PackBlobsPipeline extends ComputePipeline {
  private device: GPUDevice;
  private layout: GPUBindGroupLayout;

  constructor(key: string, shader: GPUShaderModule, device: GPUDevice) {
    super(key,1);
    this.device = device;
    const V = GPUShaderStage.COMPUTE;

    this.layout = device.createBindGroupLayout({
      entries: [
        { binding: 0, visibility: V, buffer: { type: "read-only-storage" } },
        { binding: 1, visibility: V, buffer: { type: "read-only-storage" } },
        { binding: 2, visibility: V, buffer: { type: "storage" } },
        { binding: 3, visibility: V, buffer: { type: "storage" } },
     
    ],
    });

    this.pipeline = device.createComputePipeline({
      layout: device.createPipelineLayout({ bindGroupLayouts: [this.layout] }),
      compute: { module: shader, entryPoint: key },
    });
  }

  build(blob_buffer: GPUBuffer, video_display_buffer: GPUBuffer,
        packed_count_buffer:GPUBuffer,packed_blob_buffer:GPUBuffer): void {
    this.bindgroup = this.device.createBindGroup({
      layout: this.layout,
      entries: [
        { binding: 0, resource: { buffer: blob_buffer } },
        { binding: 1, resource: { buffer: video_display_buffer } },
        { binding: 2, resource: { buffer: packed_count_buffer } },
        { binding: 3, resource: { buffer: packed_blob_buffer } },
      ],
    });
  }
}